import React,{ Component } from "react";
import {connect} from "react-redux";
import { getSystemInfo, getLicenses, addLicense, deleteLicense} from "../../actions/actionSystemInfo";
import { Row, Col, Table, Button, Card, CardBody, CardHeader, Modal, ModalHeader, ModalBody, ModalFooter, Form, FormGroup, Label, Input, UncontrolledTooltip } from "reactstrap";
import { Link } from "react-router-dom";
import Proptypes from "prop-types";
import BreadCrumbCompo from "../../components/Breadcrumb/BreadCrumbCompo";
import ReactTable from "react-table";
import moment from "moment";
import {renderTextArea} from "../../utils/formValidations.js";
import { NotificationManager } from "react-notifications";
import { Alert } from 'reactstrap';
import LoadingSpinner from "../../components/LoadingSpinner";

const routes = [
    {name: "Home",path:"/userdashboard",isActive: false},
];

class ViewSystemInfo extends Component{
    constructor(props){
        super(props);
        this.state = {
            addLicenseModal: false,
            deleteLicenseModal: false,
            license_key: '',
            licenseId: null,
            visible: true
        };
        this.openLicenseAddModal = this.openLicenseAddModal.bind(this);
        this.toggleLicense = this.toggleLicense.bind(this);
        this.addLicense = this.addLicense.bind(this);
        this.handleAddLicenseSuccess = this.handleAddLicenseSuccess.bind(this);
        this.handleAddLicenseError = this.handleAddLicenseError.bind(this);
        this.handleLicenseChange = this.handleLicenseChange.bind(this);
        this.deleteLicenseConfirm = this.deleteLicenseConfirm.bind(this);
        this.deleteLicense = this.deleteLicense.bind(this);
        this.handleDeleteLicenseSuccess = this.handleDeleteLicenseSuccess.bind(this);
        this.handleDeleteLicenseError = this.handleDeleteLicenseError.bind(this);
        this.onDismiss = this.onDismiss.bind(this);
        this.checkUpdateVersion = this.checkUpdateVersion.bind(this);
    }
  
    componentDidMount(){
        this.props.getSystemInfo();
        this.props.getLicenses();
    }

    openLicenseAddModal(){
        this.setState({addLicenseModal: !this.state.addLicenseModal});
    }

    toggleLicense(){
        this.setState({addLicenseModal: !this.state.addLicenseModal});
    }

    addLicense(){
        let data = {};
        data.license_key = this.state.license_key;
        this.props.addLicense(data).then(() => this.handleAddLicenseSuccess()).catch(() => this.handleAddLicenseError());
    }

    handleLicenseChange(event) {
        this.setState({license_key: event.target.value});
    }

    handleAddLicenseSuccess(){
        const {system_info} = this.props;
        if(system_info.addLicenseError){
            NotificationManager.error(system_info.addLicenseError,"Add License", 6000);
        }
        else{
            NotificationManager.success("Added License Successfully","Add License", 3000);
            this.setState({addLicenseModal: false});
            this.props.getLicenses();
            this.props.getSystemInfo();
        }
    }

    handleAddLicenseError(){
        const {system_info} = this.props;
        if(system_info.addLicenseError){
            NotificationManager.error(system_info.addLicenseError,"Add License", 6000);
        }
        else {
            NotificationManager.error("Error adding license","Add License", 6000);
            this.setState({addLicenseModal: false});
            this.props.getLicenses();
            this.props.getSystemInfo();
        }
    }

    handleDeleteLicenseSuccess(){
        const {system_info} = this.props;
        if(system_info.deleteLicenseError){
            NotificationManager.error(system_info.deleteLicenseError,"Delete License", 6000);
        }
        else{
            NotificationManager.success("Deleted License Successfully","Delete  License", 3000);
            this.setState({deleteLicenseModal: false});
            this.props.getLicenses();
            this.props.getSystemInfo();
        }
    }

    handleDeleteLicenseError(){
        const {system_info} = this.props;
        if(system_info.deleteicenseError){
            NotificationManager.error(system_info.deleteLicenseError,"Delete License", 6000);
        }
        else {
            NotificationManager.error("Error deleting license","Delete License", 6000);
            this.setState({deleteLicenseModal: false});
            this.props.getLicenses();
            this.props.getSystemInfo();
        }
    }

    deleteLicenseConfirm(licenseId){
        this.setState(
            {
                deleteLicenseModal: !this.state.deleteLicenseModal,
                licenseId: licenseId
            });
    }

    deleteLicense(){
        let data = {};
        data.licenseId = this.state.licenseId;
        this.props.deleteLicense(data).then(() => this.handleDeleteLicenseSuccess()).
            catch(() => this.handleDeleteLicenseError());
    }

    onDismiss() {
        this.setState({ visible: false });
    }

    checkUpdateVersion(system_info){
        if (system_info.update.status.latest_version){
             let update_version = system_info.update.status.latest_version.split('.');
             let old_version = system_info.api.build_id.split('.');
             return update_version > old_version;
        }
        return false;



    }

    render(){
        if (this.props.getSystemInfoLoading || this.props.getLicensesLoading){
            return (<div> <LoadingSpinner /></div>);
        }
        const {system_info} = this.props;
        const { loading } = this.state;
        const columns = [{
            Header: "Expiration",
            sortable: true,
            Cell: (data) => (<div className={data.original.is_verified === true ? "" : "license_not_ok"} >{moment(data.original.expiration).format("L h:mm A")} </div>),
        },
        {
            Header: "Type",
            accessor: "license_type"
        },
        {
            Header: "Limit",
            accessor: "limit"
        },
        {
            Header: "Issued To",
            accessor: "issued_to",
        },
        {
            Header: "Actions",
            filterable: false,
            sortable: false,
            Cell: (data) => (<div className="action-btn">
                <button className="btn btn-danger" id={"Tooltipss"} href="#" onClick={() => this.deleteLicenseConfirm(data.original.license_id)}>
                    <i className="fa fa-trash-o"></i> </button>
                <UncontrolledTooltip placement="right" target={"Tooltipss"}> Delete </UncontrolledTooltip>
            </div> ),
        },
        ];
        return (
            <div>   
                <BreadCrumbCompo routes={routes}/>      
                <Row>
                    <Col sm={{ size: 8, order: 3, offset: 2 }}>
                        <Card >
                            <CardHeader>
                                <i className="fa fa-align-justify"></i> <strong>System Info</strong>
                            </CardHeader>
                            <CardBody>
                                <Row>
                                    <Col xs="12">                    
                                        <div>
                                            {system_info.system_info?
                                                <React.Fragment>
                                                    {system_info.system_info.update.status &&
                                                        this.checkUpdateVersion(system_info.system_info) &&
                                                            <Alert color="info" isOpen={this.state.visible} toggle={this.onDismiss}>
                                                                <h4>Update Available</h4>
                                                                Update Version: {system_info.system_info.update.status.latest_version}
                                                                <hr />
                                                                <a href={system_info.system_info.update.status.release_notes_url}>Release Notes</a><br/>
                                                                {system_info.system_info.update.status.alert && system_info.system_info.update.status.alert}
                                                            </Alert>}
                                                    <Table bordered>
                                                        <tbody>
                                                            <tr><td>Database Host</td><td>{system_info.system_info.db.host}</td></tr>
                                                            <tr><td>Database Version</td><td>{system_info.system_info.db.alembic_version}</td></tr>
                                                            <tr><td>API Server ID</td><td>{system_info.system_info.api.server_id}</td></tr>
                                                            <tr><td>API Server Host</td><td>{system_info.system_info.api.server_hostname}</td></tr>
                                                            <tr><td>API Server Build</td><td>{system_info.system_info.api.build_id}</td></tr>
                                                            <tr><td>API Server Zone</td><td>{system_info.system_info.api.zone_name}</td></tr>
                                                            <tr><td>Installation ID</td><td>{system_info.system_info.db.installation_id}</td></tr>
                                                            <tr><td>License Status</td><td className=
                                                            {system_info.system_info.license.status.licensed ? "license_ok" : "license_not_ok"}
                                                            >{system_info.system_info.license.status.licensed ? "OK" : "Unlicensed"}</td></tr>
                                                            <tr><td>License Type</td><td>{system_info.system_info.license.status.license_type}</td></tr>
                                                            <tr><td>License Limit</td><td>{system_info.system_info.license.status.limit}</td></tr>
                                                            <tr><td>License Limit Remaining</td><td>{system_info.system_info.license.status.limit_remaining}</td></tr>
                                                        </tbody>
                                                    </Table>
                                                </React.Fragment>:" "}
                                        </div>
                                    </Col>
                                </Row>
                            </CardBody>
                        </Card>

                        <Card >
                            <CardHeader>
                                <i className="fa fa-align-justify"></i> <strong>Licenses</strong>
                                <Button className="pull-right" size="sm" color="dark"
                                        onClick={this.openLicenseAddModal}> Add License</Button>
                            </CardHeader>
                            <CardBody>
                                {system_info.licenses ?
                                    <ReactTable
                                        columns={columns}
                                        filterable
                                        data={system_info.licenses}
                                        loading={loading}
                                        defaultPageSize={10}
                                        className="-striped -highlight site_table"
                                        defaultSorted={[{id: "expiration"}]}
                                    /> : ""}
                            </CardBody>
                        </Card>

                        <Modal isOpen={this.state.addLicenseModal} toggle={this.toggleLicense}
                               className={this.props.className}>
                            <ModalHeader toggle={this.toggleLicense}>Add License</ModalHeader>
                            <ModalBody>
                                <Form>
                                    <FormGroup>
                                    <Row>
                                        <Col>
                                            <Label for="exampleText">Enter License Key</Label>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col>
                                            <Input type="textarea" name="text" id="exampleText" onChange={this.handleLicenseChange} rows="10" />
                                        </Col>
                                    </Row>
                                </FormGroup>
                                </Form>

                            </ModalBody>
                            <ModalFooter>
                                <Button onClick={this.addLicense} size="sm" color="primary">
                                    <i className="fa fa-plus"></i>
                                    Add</Button>
                                <Button onClick={this.toggleLicense} size="sm" color="basic"><i className="fa fa-ban"></i>
                                    Cancel</Button>
                            </ModalFooter>
                        </Modal>

                        <Modal isOpen={this.state.deleteLicenseModal} toggle={this.deleteLicenseConfirm} className={this.props.className}>
                            <ModalHeader toggle={this.deleteLicenseConfirm}>Delete License  <i className="fa fa-bomb" aria-hidden="true"></i>
                            </ModalHeader>
                            <ModalBody>
                                <p>Are you sure you want to delete this license?</p>
                            </ModalBody>
                            <ModalFooter>
                                <Button onClick={this.deleteLicense} size="sm" color="danger"> <i className="fa fa-trash"></i> Delete</Button>
                                <Button onClick={this.deleteLicenseConfirm} size="sm" color="basic"><i className="fa fa-ban"></i> Close</Button>
                            </ModalFooter>
                        </Modal>

                    </Col>
                </Row>
            </div>
        );}
}

ViewSystemInfo.propTypes = {
    getSystemInfo: Proptypes.func.isRequired,
    system_info: Proptypes.object,
    licenses: Proptypes.object,
    addLicense:  Proptypes.func.isRequired,
    getLicenses: Proptypes.func.isRequired,
    addLicenseError: Proptypes.func,
    deleteLicense: Proptypes.func.isRequired,
    getSystemInfoLoading: Proptypes.bool
};

export default connect(state => 
    ({
        system_info: state.system_info || null,
        addLicenseError: state.system_info.addLicenseError || null,
        getSystemInfoLoading: state.system_info.getSystemInfoLoading || null,
        getLicensesLoading: state.system_info.getLicensesLoading || null,
    }),
dispatch => 
    ({  
        getSystemInfo: () => dispatch(getSystemInfo()),
        getLicenses: () => dispatch(getLicenses()),
        addLicense: (data) => dispatch(addLicense(data)),
        deleteLicense: (data) => dispatch(deleteLicense(data)),

    }))(ViewSystemInfo);


// WEBPACK FOOTER //
// ./src/views/SystemInfo/SystemInfo.js